import { Record } from 'immutable';
import { PaymentStatus } from './payment-status.enum';
import { PaymentModifier } from './payment-modifier';
import { Tax } from './Tax';

const PaymentRecord = Record({
  eventPaymentId: 0,
  commissionAmount: 0,
  feeAmount: 0,
  commissionCurrency: null,
  description: null,
  commissionId: null,
  fundingReferenceId: null,
  paymentReferenceId: null,
  status: null,
  createdDate: null,
  modifiedDate: null,
  createdBy: null,
  modifiedBy: null,
  eventId: 0,
  type: null,
  eventPaymentModifiers: null,
  actionReason: null,
  actionDetails: null,
  resendPaymentRequestAvailable: null,
  eventPartyId: 0,
  totalTaxAmount: 0,
  eventPaymentTaxDetail: null,
  fundAmount: 0,
  fundCurrency: null,
  forecastedCommissionAmount: null,
  oldPaymentReferenceId: null
});

export class Payment extends PaymentRecord {
  eventPaymentId: number;
  commissionAmount: number;
  feeAmount: number;
  commissionCurrency: string;
  description: string;
  commissionId: string;
  fundingReferenceId: string;
  paymentReferenceId: string;
  status: PaymentStatus;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
  eventId: number;
  type: string;
  eventPaymentModifiers: PaymentModifier[];
  actionReason: string;
  actionDetails: string;
  resendPaymentRequestAvailable: boolean;
  eventPartyId: number;
  totalTaxAmount: number;
  eventPaymentTaxDetail: Tax[];
  fundAmount: number;
  fundCurrency: string;
  forecastedCommissionAmount: number;
  oldPaymentReferenceId: string;
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment.ts